module.exports = __webpack_public_path__ + "static/popular-c7e2b618150d9ab1a068e07137479594.png";